module.exports = __webpack_public_path__ + "img/made_in_cambodia01.9fc05688.png";